import { useMemo } from "react";
import { useSelector } from "react-redux";

export function useSkillOpeningHours(skillId) {
  const openingHours = useSelector(state => state.Periods.openingHours)

  return useMemo(() => openingHours?.[skillId], [openingHours, skillId])
}
